/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiServiceGetGlobalReceipt } from '@/api/global';
export default /*#__PURE__*/_defineComponent({
  props: {
    globalTicketVer: {
      type: Object
    },
    gameInfo: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const columns = [{
      label: '设备号',
      prop: 'deviceNum'
    }, {
      label: 'SDK版本号',
      prop: 'sdkVersion'
    }, {
      label: '下单时间',
      prop: 'orderTime'
    }, {
      label: '支付时间',
      prop: 'purchaseDate'
    }, {
      label: '道具名称',
      prop: 'propName'
    }, {
      label: '渠道商品ID',
      prop: 'channelGoodsId'
    }, {
      label: '苹果订单号',
      prop: 'transactionId'
    }, {
      label: 'SDK订单号',
      prop: 'hgOrderNo'
    }, {
      label: '类型',
      prop: 'orderType',
      slot: 'orderType'
    }];
    const getTableData = () => {
      const params = {
        gid: props.gameInfo && props.gameInfo.Id,
        gpId: props.globalTicketVer && props.globalTicketVer.productId,
        deviceId: props.globalTicketVer && props.globalTicketVer.deviceId
      };
      tableLoading.value = true;
      apiServiceGetGlobalReceipt(params).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const orderTypeFormatter = computed(() => {
      return function (value) {
        if (value === 0) {
          return '<span style="color:green">普通</span>';
        } else if (value === 2) {
          return '<span style="color:orange">补单</span>';
        } else if (value === 3) {
          return '<span style="color:orange">人工补单（系统修正）</span>';
        }
        return '';
      };
    });
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    watch(() => props.globalTicketVer, val => {
      if (val) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "globalTicketVer"
      }, {
        default: _withCtx(() => [_createVNode(UTable, {
          options: columns,
          data: _unref(tableData),
          loading: _unref(tableLoading)
        }, {
          orderType: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(_unref(orderTypeFormatter)(scope.row.orderType)), 1)]),
          _: 1
        }, 8, ["data", "loading"])]),
        _: 1
      });
    };
  }
});